import { PersonIcon, EmployeeModuleCard, AppContainer } from "@egovernments/digit-ui-react-components";
import React from "react";
import { useTranslation } from "react-i18next";

const HRMSCard = () => {
  const ADMIN = Digit.Utils.hrmsAccess();
  const SUPERUSER = Digit.Utils.superUserAccess();
  console.log(SUPERUSER, "superuser");

  const { t } = useTranslation();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const { isLoading, data } = Digit.Hooks.hrms.useHRMSCount(tenantId);

  // Define all cards here
  const cards = [
    {
      Icon: <PersonIcon />,
      moduleName: t("Master Data"),
      visible: ADMIN || SUPERUSER,

      links: [
        {
          label: t("Manage Master Data"),
          link: `/digit-ui/employee/obps/master-data`,
        },
      ],
    },
    {
      Icon: <PersonIcon />,
      moduleName: t("ACTION_TEST_HRMS"),
      visible: ADMIN || SUPERUSER,
      kpis: [
        {
          count: isLoading ? "-" : data?.EmployeCount?.totalEmployee,
          label: t("TOTAL_EMPLOYEES"),
          link: `/digit-ui/employee/hrms/inbox`,
        },
        {
          count: isLoading ? "-" : data?.EmployeCount?.activeEmployee,
          label: t("ACTIVE_EMPLOYEES"),
          link: `/digit-ui/employee/hrms/inbox`,
        },
      ],
      links: [
        {
          label: t("HR_HOME_SEARCH_RESULTS_HEADING"),
          link: `/digit-ui/employee/obps/search-employee`,
        },
        {
          label: t("HR_COMMON_CREATE_EMPLOYEE_HEADER"),
          link: `/digit-ui/employee/hrms/create`,
        },
        // {
        //   label: t("Initiate Employee Transfer"),
        //   link: `/digit-ui/employee/obps/employeeTransfer/initiate`,
        // },
      ],
    },
    {
      Icon: <PersonIcon />, // You can replace with a relevant icon like <HomeIcon /> or <AssignmentIcon />
      moduleName: t("NOC MODULE"),
      visible: ADMIN || SUPERUSER,
      kpis: [
        {
          count: "-",
          label: t("CREATE_NOC"),
          link: `/digit-ui/employee/obps/noc/create`,
        },
        {
          count: "-",
          label: t("UPDATE_NOC"),
          link: `/digit-ui/employee/noc/update`,
        },
      ],
      links: [
        {
          label: t("Add/Update Bulk NOCs"),
          link: `/digit-ui/employee/obps/noc/create`,
        },

        {
          label: t("View/Edit Existing NOCs"),
          link: `/digit-ui/employee/obps/noc/view`,
        },
      ],
    },
    {
      Icon: <PersonIcon />, // You can replace with a relevant icon like <HomeIcon /> or <AssignmentIcon />
      moduleName: t("Manual & Documents"),
      visible: SUPERUSER,
      kpis: [
        {
          count: "-",
          label: t("CREATE_Manual & Documents"),
          link: `/digit-ui/employee/obps/Document/Management/create`,
        },
        {
          count: "-",
          label: t("UPDATE_Manual & Documents"),
          link: `/digit-ui/employee/obps/Document/Management/create`,
        },
      ],
      links: [
        {
          label: t("Search  Manual & Documents"),
          link: `/digit-ui/employee/obps/Document/Management/Search`,
        },
        {
          label: t("Create Manual & Documents"),
          link: `/digit-ui/employee/obps/Document/Management/create`,
        },
        {
          label: t("Create What's New"),
          link: `/digit-ui/employee/obps/New/Management/create`,
        },
        {
          label: t("Create Release"),
          link: `/digit-ui/employee/obps/New/Management/Release`,
        },
        {
          label: t("Ribbon Message"),
          link: `/digit-ui/employee/obps/New/Management/Ribbon`,
        },
      ],
    },
  ];

  return (
    <React.Fragment>
      <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap" }}>
        {cards
          .filter((card) => card.visible)
          .map((card, index) => (
            <EmployeeModuleCard key={index} {...card} />
          ))}
      </div>
    </React.Fragment>
  );
};

export default HRMSCard;
